export enum TaskType {
    Animal = "Animal",
    Birth = "Birth",
    HealthRecord = 'Health Record',
    Housing = 'Housing',
    Job = 'Job',
    Line = 'Line',
    Mating = "Mating",
}

export const SCHEDULE_TASK_TYPE = 'Schedule'
